import $ from 'jquery';
const HEADER_PAD = 150;

var header = null;

function getHeaderBottom(addHeight) {
	if (!header) {
		return HEADER_PAD;
	}

	const bounds = header.getBoundingClientRect();

	return bounds.bottom + HEADER_PAD;
}

export function scrollToElement(element) {
	if (!element) {
		return false;
	}

	const el = $(element);
	if (el.length === 0) {
		return false;
	}

	const scrollTop = el.offset().top - getHeaderBottom();

	scrollToY(scrollTop);
}

export function scrollToTop() {
	scrollToY(0);
}

function scrollToY(y) {
	$('html, body').animate({ scrollTop: y });
}

function onDocumentReady() {
	// header = document.getElementById('header');

	$(window).on('hashchange', (e) => {
		e.preventDefault();
		scrollToElement(window.location.hash);

		return false;
	});

	$(document).on('click', 'a', (e) => {
		const clicked = $(e.currentTarget).get(0);
		const hash = clicked.hash;

		if (clicked.getAttribute('href') === '#') {
			e.preventDefault();
			return false;
		}

		let target = null;
		if (hash && clicked.hostname === window.location.hostname) {
			target = $(hash).get(0);
		}

		if (target) {
			e.preventDefault();
			scrollToElement(target);
		}

		return !target;
	});
}

document.addEventListener('DOMContentLoaded', onDocumentReady);
